<template>
  <div class="wrapper">
    <div class="white_box">
      <div class="listing_view">
        <img
          :src="coverMediaItem ? coverMediaItem.google_url : '/assets/images/login-bg.jpg'"
          class="listing_image"
          style="border-radius: 0;"
        >
        <div class="map_iframe">
          <iframe
            :src="mapEmbedUrl"
            allowfullscreen
            height="200"
            referrerpolicy="no-referrer-when-downgrade"
            tyle="border:0"
          />
        </div>
      </div>

      <div class="listing_info">
        <h3 class="location_title">
          {{ location.title }}
        </h3>
        <div class="location_btns">
          <primary-anchor
            :href="location.websiteUri"
            target="_blank"
          >
            Website
          </primary-anchor>

          <primary-anchor
            v-if="location?.metadata?.mapsUri"
            :href="location.metadata.mapsUri"
            target="_blank"
          >
            Directions
          </primary-anchor>

          <primary-anchor
            v-if="canEditLocation"
            :href="`/local/business-profile/refresh/${location.id}`"
            class="tooltipster"
            title="Refresh Google Listing Information"
            @click="logRefreshListingEvent"
          >
            <i class="fas fa-sync" />
          </primary-anchor>

          <primary-anchor
            v-if="location?.metadata?.mapsUri"
            :href="location.metadata.mapsUri"
            target="_blank"
            @click="logViewListingEvent"
          >
            View listing
          </primary-anchor>
        </div>
        <p>
          <span class="review_data">
            <svg-vue
              v-for="index in location.average_review_stars"
              :key="index"
              class="star"
              icon="icons/review_star"
            />
            <a
              class="xs-ml-5"
              href="/local/business-profile/reviews"
              style="color: #1a0dab;"
            >
              {{ location.reviews_count }} Google Reviews
            </a>
          </span>
          {{ listingCategoryAndRegion }}
        </p>

        <p>
          <strong>Address:</strong> {{ locationAddress }}<br>
          <strong>Phone:</strong> <a
            href="tel:01865600281"
            style="color: #1a0dab;"
          >{{ location.phoneNumbers?.primaryPhone }}</a>
        </p>

        <div v-if="location.profile?.description">
          <h3>From {{ location.title }}</h3>
          <p>"{{ location.profile?.description ?? '' }}"</p>
        </div>
      </div>
    </div>
    <div class="notice">
      * The above is an example of what your listing might look like. Your actual listing may vary
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PrimaryAnchor from "../../../global/buttons/PrimaryAnchor";

export default {
  components: {
    PrimaryAnchor,
  },
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'location',
      'coverMediaItem',
    ]),
    locationAddress() {
      const address = [
        ...(this.location?.storefrontAddress?.addressLines || []),
        this.location?.storefrontAddress?.locality,
        this.location?.storefrontAddress?.postalCode
      ];

      return address?.filter(Boolean).join(', ');
    },
    listingCategoryAndRegion() {
      const category = location?.categories?.primaryCategory?.displayName;
      const region = location?.storefrontAddress?.regionCode;
      if (!category) {
        return '';
      }
      return `${category}${region ? `in ${region}` : ''}`
    },
    mapEmbedUrl() {
      const key = 'AIzaSyArEYXMQRVZc6h8cTvbz27AfIiDHBytqHM';

      const address = [
        this.location?.title,
        ...(this.location?.storefrontAddress?.addressLines || []),
        this.location?.storefrontAddress?.locality,
        this.location?.storefrontAddress?.regionCode,
      ].filter(item => item !== null && item !== "").join(', ');

      const encoded = encodeURIComponent(address);
      return `https://www.google.com/maps/embed/v1/place?key=${key}&q=${encoded}`;
    }
  },
  methods: {
    logViewListingEvent() {
      window.mixpanel('Google Listing Manager: View listing', { locationId: this.location?.id })
    },
    logRefreshListingEvent() {
      window.mixpanel('Google Listing Manager: Refresh listing', { locationId: this.location?.id })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .white_box {
    width: 100%;

    > .listing_view {
      display: flex;
      align-items: center;
      margin: -1.5rem -1.5rem 0 -1.5rem;
      overflow: hidden;
      border-radius: 0.75rem 0.75rem 0 0;

      > .listing_image {
        height: 200px;
        width: 50%;
      }

      > .map_iframe {
        height: 200px;
        width: 50%;

        iframe {
          width: 100%;
        }
      }
    }

    > .listing_info {
      margin-top: 1rem;
      font-size: 0.875rem;
      line-height: 1.72;
      letter-spacing: -0.00715em;
      color: #4E4E54;
      font-weight: 700;

      > h3 {
        font-weight: 700;
        line-height: 1;
        letter-spacing: -0.042em;
        color: #040707;
        font-size: 1.5rem;
        margin-bottom: .5rem;
      }

      > .location_btns {
        display: flex;
        align-items: center;
        margin-bottom: .5rem;

        > * {
          width: unset;

          &:not(:last-child) {
            margin-right: .5rem;
          }
        }
      }

      p {
        .review_data {
          display: flex;
          align-items: center;

          .star {
            height: 16px;
            width: 16px;
            margin-right: .3rem;
          }
        }

        &:not(:last-of-type) {
          margin-bottom: .5rem;
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }

  .notice {
    text-align: center;
    font-style: oblique;
    padding: 1.5rem;
  }
}
</style>
